

export function redirect() {
    window.open(
      "https://drive.google.com/file/d/1odZOrR7RdF82grX9O2MUPpHYpcJD0y43/view",
      "_blank",
      "noreferrer"
    );
  }